import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Button, Box, CssBaseline } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const RegisterSuccess = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/profile')
    }, 3000)
    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      px: 3,
      pt: 'env(safe-area-inset-top, 0px)',
      pb: 'env(safe-area-inset-bottom, 0px)',
    }}>
      <CssBaseline />
      {/* Decorative blobs */}
      <Box sx={{
        position: 'absolute',
        top: -80,
        right: -80,
        width: 260,
        height: 260,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(33,208,122,0.14) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <Box sx={{
        position: 'absolute',
        bottom: -60,
        left: -60,
        width: 200,
        height: 200,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,56,92,0.10) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
        maxWidth: 320,
      }}>
        <Box sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #21d07a 0%, #0ea860 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
          boxShadow: '0 8px 28px rgba(33,208,122,0.35)',
        }}>
          <CheckCircleIcon sx={{ color: '#fff', fontSize: 44 }} />
        </Box>

        <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
          You're all set!
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
          Welcome to SwipeeIT. Your account has been created successfully. Redirecting you to your profile…
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate('/profile')}
          sx={{
            py: 1.75,
            fontWeight: 700,
            fontSize: '1rem',
            background: 'linear-gradient(135deg, #FF385C 0%, #FF6B83 100%)',
            boxShadow: '0 4px 16px rgba(255,56,92,0.32)',
            '&:hover': {
              background: 'linear-gradient(135deg, #D4003A 0%, #FF385C 100%)',
              boxShadow: '0 6px 20px rgba(255,56,92,0.44)',
            },
          }}
        >
          Go to Profile
        </Button>
      </Box>
    </Box>
  )
}

export default RegisterSuccess
